import { render, staticRenderFns } from "./ques-feedback.vue?vue&type=template&id=596812f9&scoped=true&"
import script from "./ques-feedback.vue?vue&type=script&lang=js&"
export * from "./ques-feedback.vue?vue&type=script&lang=js&"
import style0 from "./ques-feedback.vue?vue&type=style&index=0&id=596812f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596812f9",
  null
  
)

export default component.exports